
export default {
  name: 'ViewTabs',
  props: {
    name: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      items: [
        // { name: 'Bienvenido', color: false, route: 'alertmanagement' }
      ],
      // disabledColor: '#d9d9d9',
      disabledColor: '#d0e2fd'
    }
  },
  watch: {
    name: {
      handler (val) {
        const dupItems = Array.from(this.items) as any
        const index = this.items.findIndex(x => x.name === val.name)
        if (index < 0) {
          this.items.push({ name: val.name, route: val.route })
          this.items.map((x, indx) => { indx === this.items.length - 1 ? x.color = false : x.color = true })
        } else {
          const secondIdx = dupItems.findIndex(x => x.route === this.$route.path)
          if (secondIdx >= 0) {
            dupItems.map(x => { x.color = true })
            dupItems[secondIdx].color = false
            this.items = dupItems
          }
        }
      },
      deep: true
    }
  },
  methods: {
    addItems (index, item) {
      const newItems = Array.from(this.items) as any
      // find the index of list, which is not highlighted
      const fIndex = newItems.findIndex(x => x.color === false)
      if (fIndex >= 0) {
        newItems[fIndex].color = true
        newItems[index].color = false
        this.items = newItems
      } else {
        newItems[index].color = false
        this.items = newItems
      }
      // whem user action on tab navigates to actions route
      this.$router.push(item.route).catch((err: string) => { return err }) // evitar error navegación redundante
    },
    removeTab (index) {
      // Delete the tab item from list
      if (this.items.length === 2) {
        this.items[0].color = false
      }
      if (this.items.length > 2) {
        const idx = this.items.findIndex(x => x.color === false)
        if (idx === index) {
          this.items[index - 1].color = false
        }
      }
      const tabName = this.$router.options.routes.find(item =>
        item.path === this.items[index].route
      ).name
      this.$store.dispatch('ui/removeOpenedTab', tabName)
      this.items.splice(index, 1)

      // when user removes the change the route here
      const obj = this.items.find(x => !x.color)
      if (obj) this.$router.push(obj.route).catch((err: string) => { return err }) // evitar error navegación redundante
    }
  }
}
